import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        compareQuestion: '=',
        counter: '=',
        title: '=',
        compareTitle: '='
    },
    template: `
        <h4>{{ vm.counter }}. {{ vm.question.nameWithoutHtml }}</h4>
        <ul class="ticks">
            <li ng-repeat="answer in vm.question.questionAnswers">{{ answer.text }}</li>
        </ul>
        <dl ng-repeat="childQuestion in vm.question.childQuestions" ng-init="average=vm.getAverage(childQuestion.id)">
            <dt>{{ childQuestion.nameWithoutHtml }}</dt>
            <dd>
                <span>
                    <span ng-if="vm.compareTitle && average" class="title" >
                    <strong class="ng-binding">{{ vm.title }}</strong>
                    </span>
                    <span class="result" ng-style="{ width: vm.SurveyReportService.getWidth(average, vm.answerCount) }">
                        <span>{{ average | number: 1 }}</span>
                    </span>
                </span>
                <span ng-if="vm.compareQuestion">
                    <span class="title" ng-if="vm.compareTitle && vm.getCompareAverage(childQuestion.id)">
                        <strong class="ng-binding">{{ 'survey.Comparison' | translate }}</strong>
                    </span>
                    <span ng-if="vm.compareQuestion && vm.getCompareAverage(childQuestion.id)"
                        class="result result02"
                        ng-style="{ marginTop: '0px', width: vm.SurveyReportService.getWidth(vm.getCompareAverage(childQuestion.id), vm.answerCount) }">
                        <span>{{ vm.getCompareAverage(childQuestion.id) | number: 1 }}</span>
                    </span>
                </span>
            </dd>
        </dl>
    `
})
export default class {
    constructor (lodash, SurveyReportService, QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM) {
        this.lodash = lodash;
        this.SurveyReportService = SurveyReportService;
        this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM = QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM;
    }

    $onInit () {
        this.question.questionAnswers = this.question.questionAnswers
            .filter(answer => answer.correctness !== this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.NOT_APPLICABLE);
        this.answerCount = this.question.questionAnswers.length;

        if (this.compareQuestion) {
            this.compareQuestion.questionAnswers = this.compareQuestion.questionAnswers
                .filter(answer => answer.correctness !== this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.NOT_APPLICABLE);

            if (this.compareQuestion.questionAnswers.length > this.answerCount) {
                this.answerCount = this.compareQuestion.questionAnswers.length;
            }
        }
    }

    getAverage (childQuestionId) {
        const average = this.lodash.get(this.question, `answerOptions.${childQuestionId}.average`, 0);
        return parseFloat(average);
    }

    getCompareAverage (childQuestionId) {
        if (!this.compareQuestion) {
            return 0;
        }
        const average = this.lodash.get(this.compareQuestion, `answerOptions.${childQuestionId}.average`, 0);
        return parseFloat(average);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/question/matrix/index.js